export enum SimCardType {
    None = "None",
    Eseye = "Eseye"
}

export enum DeviceTopologyEventType {
    GatewayProvisioned = "GatewayProvisioned",
    GatewayDeprovisioned = "GatewayDeprovisioned",
    GatewayReplaced = "GatewayReplaced",
    GatewayDeleted = "GatewayDeleted",
    GatewayUpdated = "GatewayUpdated",
    SensorProvisioned = "SensorProvisioned",
    SensorDeprovisioned = "SensorDeprovisioned",
    SensorReplaced = "SensorReplaced",
    SensorDeleted = "SensorDeleted",
    SensorUpdated = "SensorUpdated",
}

export enum Protocol {
    V1 = "v1",
    V2 = "v2",
    BLE = "ble"
}